export default __webpack_public_path__ + "static/media/demo_optical.f84a725a.jpg";